import { segment } from '@actions/analytics';
import { useRouter } from 'next/router';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { getPlusSubscriptionInfo } from '@selectors/subscription';
import { useSelector } from 'react-redux';
import { getTopologyDataByUID } from '@selectors/topologies';

const useDSTSegmentAnalytics = () => {
  const router = useRouter();
  const {
    query: { goalUID }
  } = router;

  const goalDetails = useSelectorWithShallowEqual(
    getTopologyDataByUID(goalUID)
  );

  const {
    subscription = {},
    expired_at,
    time_remaining
  } = useSelector(getPlusSubscriptionInfo(goalUID)) ?? {};

  return (actionKey, additionalProps = {}) => {
    segment.track(actionKey, {
      goal_name: goalDetails.name,
      goal_uid: goalUID,
      test_type: 'Objective',
      programme_type: 'Test Series',
      test_eligibility_type: 'Scholarship Test',
      is_invited: false,
      subscription_end_date: expired_at ?? 'NA',
      subscription_duration: subscription.duration ?? 'NA',
      is_subscription_active: time_remaining > 0,
      ...additionalProps
    });
  };
};

export default useDSTSegmentAnalytics;
